export const url = {
    path : 'https://amie-jobs.vercel.app',
};
// path : 'http://localhost:5000',